import { render, staticRenderFns } from "./Retensi.vue?vue&type=template&id=44640739&"
import script from "./Retensi.vue?vue&type=script&lang=js&"
export * from "./Retensi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports